export default "__VITE_ASSET__DpYOx_Yx__"